import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import Logo from "./Logo";
import { COMPANY } from "../data/content";
import { openCookieSettings } from "./CookieConsent";
import { useI18n } from "../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useI18n();
  const f = t.footer;

  return (
    <footer className="bg-[#0f2747] text-white pt-16 pb-8" data-testid="main-footer">
      <div className="max-w-[1320px] mx-auto px-5 lg:px-8">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="bg-white inline-flex rounded-md px-3 py-2 mb-5">
              <Logo height={44} />
            </div>
            <p className="text-blue-200 text-sm leading-relaxed max-w-xs">
              {f.companyDesc}
            </p>
            
          </div>

          <div>
            <h4 className="font-head font-bold text-sm uppercase tracking-wider mb-5 text-blue-100">{f.contactTitle}</h4>
            <ul className="space-y-3 text-blue-100/90 text-sm">
              <li className="flex items-center gap-3"><MapPin size={17} className="text-blue-400" /> {COMPANY.zip}</li>
              <li className="flex items-center gap-3"><Phone size={17} className="text-blue-400" /> {COMPANY.phone}</li>
              <li className="flex items-center gap-3"><Mail size={17} className="text-blue-400" /> {COMPANY.email}</li>
            </ul>
          </div>

          <div>
            <h4 className="font-head font-bold text-sm uppercase tracking-wider mb-5 text-blue-100">{f.legalTitle}</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/impressum" data-testid="footer-impressum" className="text-blue-100/90 hover:text-white transition-colors">{f.impressum}</Link></li>
              <li><Link to="/datenschutz" data-testid="footer-datenschutz" className="text-blue-100/90 hover:text-white transition-colors">{f.datenschutz}</Link></li>
              <li>
                <button
                  type="button"
                  data-testid="footer-cookie-settings"
                  onClick={openCookieSettings}
                  className="text-blue-100/90 hover:text-white transition-colors text-left"
                >
                  {f.cookieSettings}
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-blue-200/70">
          <span>© {new Date().getFullYear()} {COMPANY.name} – {f.companyDesc}</span>
          <span>{f.bottomTagline}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
